<template>
    <div class="pago-con-dni">
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card style="margin: 20px">
            <b-card-header header-tag="header" class="p-1" role="tab">
                Pagá con DNI
            </b-card-header>
            <b-card-body>
                <div class="row">
                    <div class="form-check-inline">
                        <Label class="h3 mt-1">Permitir pagos con DNI</Label>
                        <resimple-switch ref="switch-dni-payment" class="ml-3" v-model="acceptDniPayment" v-on:change="onChangeAcceptDniPayment"/>
                    </div>
                </div>
                <div class="initial-section" v-if="!acceptDniPayment">
                    <div class="row">
                        <div class="col-md-12 text-center" style="color:#ff5955;">
                            <span>Los pagos con DNI son una opción simple y segura exclusiva de tu billetera resimple.</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <img v-bind:src="exampleDNI" class="responsiveImage" style="max-width:280px;"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <span>Presentando tu DNI en un comercio, junto con una clave, podés pagar sin necesidad de tener tu celular encima. El comercio solo necesita poder escanear tu documento y listo. ¡Probalo!</span>
                        </div>
                    </div>
                </div>
                <div class="configuration-section" v-else>
                    <div class="row dividing-line"/>
                    <div class="row clave-pin pointer" @click="goToPinConfiguration">
                        <div class="col-6 col-left">
                            <span class="h3">Clave Pin</span>
                        </div>
                        <div class="col-6 text-right col-right">
                            <span>{{ pinKeyConfigured ? "Configurada" : "No configurada" }} &gt;</span>
                        </div>
                    </div>
                    <div class="row dividing-line"/>
                    <div class="row importe-maximo">
                        <div class="col-6 col-left">
                            <span class="h3">Importe máximo</span>
                        </div>
                        <div class="col-6 text-right col-right mt-1">
                            <span>$ {{ maxPaymentAmount }}</span>
                        </div>
                    </div>
                    <resimple-slider class="resimple-slider" v-model="maxPaymentAmount" :range="ammountRange" :interval="500"/>
                    <div class="row mb-2">
                        <div class="col-md-12 text-center">
                            <span>Seleccioná el importe máximo por operación </span>
                            <span>entre $ {{ammountRange.min}} y $ {{ammountRange.max}}</span>
                        </div>
                    </div>
                    <div class="row dividing-line"/>
                    <div class="row imagen-dni">
                        <div class="col-md-12 text-center col-sin-padding mt-2 mb-2">
                            <img v-bind:src="photo" class="responsiveImage" style="max-width:280px;"/>
                        </div>
                        <div class="margin-top col-md-12 text-center">
                            <!-- Uploader de Imagenes -->
                            <image-uploader
                                :preview="false"
                                :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                                capture="environment"
                                :maxHeight="300"
                                outputFormat="verbose"
                                @input="setImage">
                                <label for="fileInput" slot="upload-label" style="cursor:pointer">
                                    <figure>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="32"
                                            height="32"
                                            viewBox="0 0 32 32">
                                            <path
                                                class="path1"
                                                d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                                            />
                                        </svg>
                                    </figure>
                                    <span class="upload-caption">
                                        {{ hasImage ? "Cambiar" : "Subir" }}
                                    </span>
                                </label>
                            </image-uploader>
                            <!-- Uploader de Imagenes -->
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <span>La Foto del DNI permite que el comercio sepa que sos vos al momento de pagar</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group" style="margin-top: 20px">
                        <div class="col-md-12 text-center">
                            <save-button @click="save"/>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<style lang="scss">
    .pago-con-dni {
        .h3 {
            color: #ff5855;
        }

        .dividing-line {
            border-top: 1px solid rgb(208, 208, 208);
        }

        .pointer {
            cursor: pointer;
        }

        .clave-pin,
        .importe-maximo,
        .imagen-dni {
            vertical-align: middle;
            margin-top: 4px;
            margin-bottom: 4px;
            .col-right {
                padding-right: 0px;
            }
            .col-left {
                padding-left: 0px;
            }
        }

        .col-sin-padding {
            padding-right: 0px;
            padding-left: 0px;
        }

        input[type="file"] {
            display: none;
        }
    }
</style>

<script>
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";
import ResimpleSlider from "@/components/Custom/ResimpleSlider";
import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);
import Vue from "vue";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
    name: "PagoConDNI",
    components: {
        "resimple-switch": ResimpleSwitch,
        "resimple-slider": ResimpleSlider
    },
    data() {
        return {
            acceptDniPayment: false,
            exampleDNI: 'img/dni_muestra.png',
            ammountRange: {
                min: 0,
                max: 5000
            }, 
            maxPaymentAmount: 0,
            hasImage: false,
            image: null,
            photoDefault: 'img/ob_req_dnif_sin_margen.png',
            extension: '',
            photo: 'img/ob_req_dnif_sin_margen.png',
            photoClear: '',
            paymentPIN: '',
            showSuccess: true            
        };
    },
    computed: {
        pinKeyConfigured() {
            return (this.paymentPIN != null && this.paymentPIN != "") ? true : false;
        }
    },
    methods: {
        onChangeAcceptDniPayment() {
            if(!this.acceptDniPayment) {
                this.showSuccess = false;
                this.save();
            }
        },
        goToPinConfiguration() {
            this.$router.push({
                name: "pinconfiguration",
                params: {
                    currentPinProp: this.paymentPIN,
                    activatePinProp: false,
                    routeGoToAfterFinishProp: 'pagocondni'
                }
            });
        },
        setImage(output) {
            // -- Indica si esta cambiando la imagen (Previamente cargo una, y la cambia por otra)
            let isUpdate = (this.photo != this.photoDefault);
            let context = this;
            this.image = output;
            this.extension = output.type.replace("image/",'');
            this.hasImage = true;
            this.photo = this.image.dataUrl;
            this.photoClear = this.photo.replace("data:image/"+ this.extension + ";base64,",'');
            if(isUpdate)
                this.$forceUpdate();
        },
        save() {
            let context = this;
            let req = {
                FileStream: context.photoClear,
                Extension: context.extension,
                AcceptDNIPayment: context.acceptDniPayment,
                MaxPaymentAmount: context.maxPaymentAmount,
                CroppedImage: true,
                AddImage: context.image != null ? true : false
            };

            axiosHelpers.axiosPost('Account/SaveAcceptDniPaymentWithImage', req, this, function(data) {
                if (data.ResponseVM.Resultado) {
                    if(context.showSuccess) {
                        notificationHelpers.showSuccess('Exito', 'La operación se realizó correctamente.', context);
                    } else {
                        context.showSuccess = true;
                    }
                }
            });
        },
        getAcceptDniPayment(context) {
            axiosHelpers.axiosGet("Account/GetAcceptDniPayment", {}, context, function(data) {
                if(data.Alerts.length == 0) {
                    context.acceptDniPayment = data.ResponseVM.AcceptDNIPayment;
                    context.maxPaymentAmount = data.ResponseVM.MaxPaymentAmount;
                    context.paymentPIN = data.ResponseVM.PaymentPIN;

                    if(data.ResponseVM.Base64Image != null) {
                        var extension = data.ResponseVM.ImageExtension;
                        context.photo = "data:image/" + extension + ";base64," + data.ResponseVM.Base64Image;
                        context.hasImage = true;
                    }
                }
            });
        }
    },
    beforeMount() {
        this.getAcceptDniPayment(this);
    }
}
</script>
